/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'
import type { Plan } from './plan'
import type { ThemeMode } from './themeMode'

export interface PublicTenant {
  /**
   * CTAボタンのデフォルト背景色（不透明HEX #RRGGBB）。未設定なら null。
   * @nullable
   */
  defaultButtonColor: string | null
  plan: Plan
  /** @nullable */
  logoUrl: string | null
  themeMode: ThemeMode
  name: string
  id: Cuid
}
